import{stylePropsToThemeKeys as o}from"../shared/constants.mjs";const s=s=>s in o;export{s as isThemeStylePropKey};
